"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function (organizationId) {
        return api_base_1.default.get("organizations/" + organizationId + "/public_logo").then(function (response) { return response.data.data; });
    }
};
//# sourceMappingURL=public_logo_api.js.map